module.exports = __webpack_public_path__ + "static/cloud-storage-copy@2x-02e1a1ca27307684bdad627c9e31f100.png";